module.exports = __webpack_public_path__ + "media/images/header-salon-7c744d63f9565153da06b0160644e608.png";